// #region Konstanten
const Validation_Succeeded = 'succeeded';
const Validation_Invalid = 'invalid';
// #endregion
// #region Imports
import { defineComponent, nextTick } from "vue";
import { FormsValidator } from "../../services/validator";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-ozg-wizard-page',
    // #endregion
    // #region Properties
    data: () => ({
        process: {},
        schema: {},
        data: {},
        totalPageNumber: 0,
        isLoading: false,
        validator: new FormsValidator(),
        currentPage: null,
        errorMessage: [],
    }),
    computed: {
        pages() {
            return this?.schema?.pages ?? [];
        },
        allMessages() {
            return forms.getAllErrorMessages(this.currentPage, this.errorMessage);
        },
        currentPageNumber() {
            return this.currentPage?.number;
        },
        processId() {
            return this.$route.params.process;
        },
        currentPageId() {
            return this.$route.params.page;
        },
        allPages() {
            let tPages = [];
            {
                this.$forms.getAllPages(tPages, this.schema.pages ?? []);
            }
            return tPages;
        }
    },
    // #endregion
    // #region Constructor
    async created() {
        this.load();
    },
    async beforeMount() {
        // #region Bus
        this.$host.eventBus.on('router-beforeLeave', this.routeLeave);
        // #endregion
    },
    beforeUnmount() {
        this.$host.eventBus.off('router-beforeLeave', this.routeLeave);
    },
    // #endregion
    // #region Watcher
    watch: {
        currentPageId: {
            handler: async function (newValue, oldValue) {
                if (this.isLoading) {
                    return;
                }
                if (!newValue) {
                    return;
                }
                if (!this.currentPage || this.currentPage.name !== newValue) {
                    await this.setCurrentPage();
                    this.setPageTitel();
                }
            }
        },
    },
    // #endregion
    // #region Methods
    methods: {
        // #region Calculate
        async load() {
            // #region Start
            this.isLoading = true;
            // #endregion
            // #region Load
            let tData = await this.$host.api.get('/forms/processes/' + this.processId);
            // #endregion
            // #region Vars
            if (tData.data) {
                this.schema = tData.data ?? {};
                this.process = tData.data ?? {};
                this.data = tData?.data?.data ?? {};
            }
            // #endregion
            // #region BreadCrumb
            if (this.process) {
                let tBreadcrumb = [
                    { "caption": "Anträge", "address": "/ozg", "active": false },
                    { "caption": 'Bearbeiten', "active": true }
                ];
                this.$store.commit('navigation/setBreadcrumb', tBreadcrumb);
            }
            // #endregion
            // #region Calculate
            //Run
            this.calculate();
            await this.setCurrentPage();
            this.calculate();
            this.setPageTitel();
            //Load
            this.isLoading = false;
            // #endregion
        },
        calculate() {
            // #region Vars
            let tNumber = 1;
            let tFirst = true;
            let tTemp = [];
            let tPageLock = false;
            let tHasInvalid = false;
            let tHasInvalidWithNo = false;
            let tIsConfirmed = this.process.processState !== 'N';
            // #endregion
            // #region Reset
            this.errorMessage = [];
            // #endregion
            // #region Prepare
            //Schema
            this.schema.allPages = forms.getAllPagesAsObject(this.pages);
            //Cache
            this.$forms.getAllPages(tTemp, this.pages, e => e.pageType !== 'group');
            // #endregion
            // #region Calculate
            //Run
            tTemp.forEach(e => {
                // #region Validation
                if (e.pageType === 'data') {
                    e.validationState = this.$forms.isFinished(e);
                    e.isValid = this.$forms.isValid(e.validationState);
                }
                else if (e.pageType === 'summary') {
                    if (e.lockIfInvalid) {
                        e.validationState = tHasInvalid ? 'invalid' : 'valid';
                        e.isValid = !tHasInvalid;
                    }
                    else {
                        e.validationState = 'none';
                        e.isValid = true;
                    }
                }
                else {
                    e.validationState = null;
                    e.isValid = this.$forms.isValid(e.validationState);
                }
                if (!e.isValid || e.validationState === 'none') {
                    tHasInvalidWithNo = true;
                }
                if (!e.isValid) {
                    tHasInvalid = true;
                }
                // #endregion
                // #region Locked
                if (e.pageType === 'confirmed') {
                    e.isEnabled = tIsConfirmed;
                }
                else if (e.pageType === 'dummy') {
                    e.isEnabled = false;
                }
                else {
                    if (tHasInvalidWithNo && e.lockIfInvalidBefore) {
                        e.isEnabled = false;
                    }
                    else {
                        if (tPageLock) {
                            e.isEnabled = false;
                        }
                        else if (tIsConfirmed) {
                            e.isEnabled = false;
                        }
                        else {
                            e.isEnabled = forms.isEnabled(e, forms.getDataForEval(this.schema, this.data, e));
                        }
                    }
                }
                // #endregion
                // #region Fields
                if (e.content) {
                    //Data
                    let tPageData = this.$forms.getDataForEval(this.schema, this.data, e);
                    //Run
                    e.content.forEach((el) => {
                        el.isVisible = this.$forms.isVisible(el, tPageData);
                    });
                }
                // #endregion
                // #region Next
                if ((e.lockIfInvalid && !e.isValid) || e.validationState === 'critical') {
                    tPageLock = true;
                }
                // #endregion
                // #region Flow
                if (e.isEnabled) {
                    e.isFirstPage = tFirst;
                    e.number = tNumber;
                    tFirst = false;
                    tNumber = tNumber + 1;
                }
                else {
                    e.number = 0;
                }
                // #endregion
            });
            // #endregion
            // #region Flow
            var tLast = tTemp.slice().reverse().find(e => e.isEnabled);
            tLast.isLastPage = true;
            let tPreviousPageName;
            tTemp.forEach(e => {
                e.previousPage = tPreviousPageName;
                if (e.isEnabled) {
                    tPreviousPageName = e.name;
                }
            });
            let tLastPageName;
            tTemp.slice().reverse().forEach(e => {
                // #region Text
                if (!e.nextText) {
                    e.nextText = 'Weiter >>';
                }
                // #endregion
                // #region Command
                if (e.nextCommand) {
                    if (e.lockIfInvalid && !e.isValid) {
                        e.nextCommand2 = e.undefined;
                        e.nextPage = undefined;
                    }
                    else if (e.nextCondition) {
                        if (forms.isEvalValid(e.nextCondition, forms.getDataForEval(this.schema, this.data, e))) {
                            e.nextCommand2 = e.nextCommand;
                            e.nextPage = tLastPageName;
                        }
                        else {
                            e.nextCommand2 = undefined;
                            e.nextPage = undefined;
                        }
                    }
                    else {
                        e.nextCommand2 = e.nextCommand;
                        e.nextPage = tLastPageName;
                    }
                }
                // #endregion
                // #region Default
                else if (tLastPageName) {
                    e.nextCommand2 = 'next';
                    e.nextPage = tLastPageName;
                }
                else {
                    e.nextCommand2 = undefined;
                    e.nextPage = undefined;
                }
                // #endregion
                if (e.isEnabled) {
                    tLastPageName = e.name;
                }
            });
            //Total
            this.totalPageNumber = tTemp.filter(e => e.isEnabled).length;
            // #endregion
        },
        // #endregion
        // #region Helper
        getPages() {
            let tTarget = [];
            {
                this.$forms.getAllPages(tTarget, this.pages);
            }
            return tTarget;
        },
        refresh() {
            //TODO
        },
        setPageTitel() {
            nextTick(() => {
                this.$host.pageMeta.title = this.currentPage.titleNumber + ' ' + this.currentPage.title;
            });
        },
        setErrorMessage(errorText) {
            if (!errorText) {
                return;
            }
            this.errorMessage.push({
                text: errorText
            });
        },
        // #endregion
        // #region Navigation
        async routeLeave() {
            await this.Commit(this.currentPage?.name);
        },
        async setCurrentPage() {
            // #region Vars
            let tID = this.currentPageId;
            // #endregion
            // #region Update
            let tPage = this.$forms.findPageByName(this.pages, this.$route.params.page);
            {
                if (!tPage || !tPage.isEnabled) {
                    tPage = this.$forms.findFirstPage(this.pages);
                }
            }
            // #endregion
            // #region Activate
            if (tPage.hasActivateCallback) {
                await this.$host.api.put('/forms/processes/' + this.processId + '/activate', undefined, { params: { pageID: tPage.name } });
            }
            // #endregion
            // #region Set
            this.currentPage = tPage;
            // #endregion
            // #region Route
            if (this.currentPageId && this.currentPageId !== tPage.name) {
                this.$router.replace({ path: tPage.pageLink.replace('to://', '') });
            }
            // #endregion
        },
        onGotoPage(e) {
            // #region Page
            if (utils.isObject(e)) {
                if (e.pageLink) {
                    this.$router.push(e.pageLink.replace('to://', ''));
                    window.scrollTo(0, 0);
                }
            }
            // #endregion
            // #region Find by Name
            else if (utils.isString(e)) {
                //Find
                let tPage = this.$forms.findPageByName(this.pages, e);
                //Set
                if (tPage) {
                    this.$router.push(tPage.pageLink.replace('to://', ''));
                    window.scrollTo(0, 0);
                }
            }
            // #endregion
        },
        onGotoMaster(e) {
            if (e.pageLink) {
                this.$router.push(e.pageLink.replace('to://', '').substring(0, e.pageLink.replace('to://', '').lastIndexOf('_')));
                window.scrollTo(0, 0);
            }
        },
        onNext() {
            // #region Validate
            if (this.currentPage) {
                this.onPageValidate(this.currentPage);
            }
            // #endregion
            // #region Run
            this.onGotoPage(this.currentPage.nextPage);
            // #endregion
        },
        onPrevious() {
            // #region Run
            this.onGotoPage(this.currentPage.previousPage);
            // #endregion
        },
        showMobileNav() {
            host.notification.showModal2(host.components.getComponent('g-ozg-nav-mobile'), { label: `Antrag: ${this.process.processNumber}`, currentPage: this.currentPage, pages: this.pages }, { variant: "slide", position: "end", size: "default" });
        },
        async onSubmit() {
            // #region Reset
            this.errorMessage = [];
            // #endregion
            // #region Validate
            if (this.currentPage) {
                this.onPageValidate(this.currentPage);
            }
            // #endregion
            // #region Run
            try {
                //Send
                let tResult = await this.$host.api.put('/forms/processes/' + this.processId + '/submit');
                //Error
                if (!tResult.data.isSucceeded) {
                    this.setErrorMessage(tResult.data.message);
                }
                else {
                    this.onElementCommand("reload-and-next", {});
                }
            }
            catch (e) {
                this.setErrorMessage(utils.getAxiosErrorMessage(e));
            }
            // #endregion
        },
        // #endregion
        // #region Multi-Pages
        onAddPage(page) {
            // #region Load
            this.$host.api.post('/forms/processes/' + this.processId + '/pages/' + page.name)
                .then(e => {
                // #region Vars
                let tPage = e.data.page;
                // #endregion
                // #region Set
                if (tPage) {
                    //Push
                    page.pages.push(tPage);
                    //Calculate
                    this.calculate();
                    //Move
                    this.onGotoPage(tPage);
                }
                // #endregion
            })
                .catch(e => {
                host.notification.showError(e);
            });
            // #endregion
        },
        onRemovePage(master, page) {
            // #region Data
            page.content.forEach((c) => {
                c.fields.forEach((f) => {
                    delete this.data[f.member];
                });
            });
            // #endregion
            // #region Remove
            if (master) {
                master.pages.splice(master.pages.indexOf(page), 1);
            }
            // #endregion
            // #region Calculate
            this.calculate();
            this.Commit(master?.name);
            // #endregion
        },
        // #endregion
        // #region Fields
        onFieldAdd(field) {
            // #region Vars
            let tIndex = 1;
            let tMember = field?.member + "_" + tIndex;
            while (field?.fields.some(f => f.member === tMember)) {
                tIndex = tIndex + 1;
                tMember = field?.member + "_" + tIndex;
                ;
            }
            // #endregion
            // #region Append
            field?.fields.push({
                member: tMember,
                index: field.fields.length + 1
            });
            // #endregion
            // #region Renumber
            //Vars
            let tIndex1 = 0;
            //Run
            field?.fields.forEach((e) => {
                e.index = tIndex1;
                tIndex1 = tIndex1 + 1;
            });
            // #endregion
        },
        onFieldRemove(element, field) {
            // #region Data
            delete this.data[field.member];
            // #endregion
            // #region Remove
            element?.fields.splice(element?.fields.indexOf(field), 1);
            // #endregion
            // #region Renumber
            //Vars
            let tIndex1 = 0;
            //Run
            element?.fields.forEach((e) => {
                e.index = tIndex1;
                tIndex1 = tIndex1 + 1;
            });
            // #endregion
            // #region Validate
            this.onPageValidate(this.currentPage, true);
            // #endregion
        },
        // #endregion
        // #region Validation
        onFieldValidate(element, field, page, isSingle = false) {
            // #region Vars
            let tValue = this.data[field.member];
            // #endregion
            // #region Empty
            if (element.validationRules) {
                //Run
                let tResult = this.validator.validate({ displayName: element.element.label }, element.validationRules, tValue, forms.getDataForEval(this.schema, this.data, page));
                //set
                if (tResult.isValid) {
                    field.validation = {
                        state: 'succeeded'
                    };
                }
                else {
                    field.validation = {
                        state: tResult.isCritical ? 'critical' : 'invalid',
                        message: tResult.message,
                        showAsMessage: tResult.showAsMessage
                    };
                }
            }
            else {
                field.validation = {
                    state: 'none'
                };
            }
            // #endregion
            // #region related values
            if (field.validation?.state === 'succeeded' && element.hasRelatedValues) {
                //Find
                var tOption = element.element?.options?.find(f => f.value === this.data[field.member]);
                //Data
                if (tOption && tOption.relatedValues) {
                    //Values
                    Object.keys(tOption.relatedValues).forEach(f => {
                        //Values
                        this.data[f] = tOption.relatedValues[f];
                        //Fields
                        let tField = forms.getElementWithPageByMember(this.allPages, f);
                        if (tField) {
                            this.onFieldValidate(tField.element, tField.field, tField.page, false);
                        }
                    });
                }
            }
            // #endregion
            // #region Page
            if (page) {
                page.validationState = this.$forms.isFinished(page);
                page.isValid = this.$forms.isValid(page.validationState);
            }
            // #endregion
            // #region Calculate
            if (isSingle) {
                this.calculate();
            }
            // #endregion
        },
        onPageValidate(page, force = false, calculate = true) {
            // #region Check
            if (!page) {
                return;
            }
            if (!page.content) {
                return;
            }
            if (!page.isEnabled) {
                return;
            }
            // #endregion
            // #region Run
            page.content.forEach((e) => {
                if (e.validationRules) {
                    e.fields.forEach((f) => {
                        if ((!f.validation?.state || f.validation?.state === 'pending') || force) {
                            this.onFieldValidate(e, f, page);
                        }
                    });
                }
            });
            // #endregion
            // #region Calculate
            if (calculate) {
                this.calculate();
            }
            // #endregion
        },
        // #endregion
        // #region Commands
        async onElementCommand(command, args, callback) {
            if (command === 'next') {
                this.onNext();
            }
            else if (command === 'submit') {
                await this.onSubmit();
            }
            else if (command === 'back' || command === 'previous') {
                this.onPrevious();
            }
            else if (command === 'page-add') {
                this.onAddPage(args.page);
            }
            else if (command === 'page-goto') {
                this.onGotoPage(args.page);
            }
            else if (command === 'page-goto-master') {
                this.onGotoMaster(args.page);
            }
            else if (command === 'page-remove') {
                this.onRemovePage(args.master, args.page);
            }
            else if (command === 'commit') {
                await this.Commit(this.currentPage.name);
            }
            else if (command === 'calculate') {
                this.calculate();
            }
            else if (command === 'field-add') {
                this.onFieldAdd(args.element);
            }
            else if (command === 'field-remove') {
                this.onFieldRemove(args.element, args.field);
            }
            else if (command === 'field-validate') {
                this.onFieldValidate(args.element, args.field, this.currentPage, true);
            }
            else if (command === 'reload-and-next') {
                await this.load();
                this.onNext();
            }
            else if (command === 'show-mobile-nav') {
                this.showMobileNav();
            }
            if (callback) {
                callback();
            }
        },
        // #endregion
        // #region CRUD
        async Commit(pageID) {
            // #region Check
            if (!this.process.isActive) {
                return;
            }
            // #endregion
            // #region Calculate
            this.calculate();
            // #endregion
            // #region Data
            let tData = {
                entry: this.data,
                pages: {},
                elements: {},
            };
            this.getPages().forEach((e) => {
                // #region Page
                tData.pages[e.name] = {
                    isEnabled: e.isEnabled,
                    validationState: e.validationState,
                };
                // #endregion
                // #region Multi
                if (e.pageType === 'multi') {
                    tData.pages[e.name].pages = [];
                    e.pages.forEach((f) => {
                        tData.pages[e.name].pages.push({
                            name: f.name,
                            member: f.member,
                            isLocked: f.pageType === 'dummy'
                        });
                    });
                }
                // #endregion
                // #region Fields
                if (e.content) {
                    e.content.forEach((c) => {
                        if (!c.isVisible) {
                            if (!tData.elements[c.member]) {
                                tData.elements[c.member] = {};
                            }
                            tData.elements[c.member].isVisible = false;
                        }
                        if (c.fields) {
                            c.fields.forEach((f) => {
                                if (c.fields.length > 1 || forms.isValidationStateForSave(f.validation?.state)) {
                                    if (!tData.elements[c.member]) {
                                        tData.elements[c.member] = {};
                                    }
                                    if (!tData.elements[c.member].fields) {
                                        tData.elements[c.member].fields = [];
                                    }
                                    tData.elements[c.member].fields.push({
                                        member: f.member,
                                        index: f.index,
                                        validation: f.validation
                                    });
                                }
                            });
                        }
                    });
                }
                // #endregion
            });
            // #endregion
            await this.$host.api.put('/forms/processes/' + this.processId, tData, { params: { pageID: pageID } });
        },
        // #endregion
    }
    // #endregion
});
// #endregion
